import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { RouteGuard } from 'src/app/core/route-guards/route-guard.guard';
import { AnalyticsComponent } from './components/analytics/analytics.component';
import { UserRoleNames } from 'src/app/core/models/users';

const routes: Routes = [
    {
        path: "Analytics",
        component: AnalyticsComponent,
        canActivate: [RouteGuard],
        data: {
            role: [
              UserRoleNames.GlobalAdmin,
              UserRoleNames.PowerUser,
              UserRoleNames.DeploymentAdmin,
            ],
          },
    }
]

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
  })
  export class ApplicationRoutingModule {}